export default {
	'hide-zero-lines': 'hide zero lines'
}